import React, { useState } from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';

export default function InvoiceSummary({ checked, onChange, hidden }) {
  return (
    <div
      className={`sub-card ${hidden ? 'card-disabled' : ''}`}
      id="invoice-summary"
    >
      <div className="garden-wall-card-header">
        <h4 className="card-title">Invoice summary</h4>
        <CustomSwitch
          checked={checked} // from parent
          onChange={onChange} // from parent
          size="small" // small | medium | large
          color="var(--primary-color)"
        />
      </div>
      <div className="garden-wall-normal-card">
        <h5 className="invoice-title" style={{ margin: '20px 0' }}>
          Invoice date
        </h5>
        <div className="invoice-summary-group">
          <div className="invoice-row">
            <p className="invoice-summary-label">Previous balance</p>
            <p className="invoice-summary-value">+$224.77</p>
          </div>
          <div className="invoice-row">
            <p className="invoice-summary-label">Previous balance</p>
            <p className="invoice-summary-value">-$224.77</p>
          </div>
          <div className="invoice-row">
            <p className="invoice-summary-label">Adjustments</p>
            <p className="invoice-summary-value">-$75.00</p>
          </div>
        </div>
        <div className="invoice-row" style={{ margin: '20px 0' }}>
          <h5 className="invoice-title">Balance</h5>
          <p className="invoice-summary-price">+$75.00</p>
        </div>
        <div className="invoice-summary-group">
          <div className="invoice-row">
            <p className="invoice-summary-label">Monthly service charges</p>
            <p className="invoice-summary-value">+$224.77</p>
          </div>
          <div className="invoice-row">
            <p className="invoice-summary-label">Usage charges</p>
            <p className="invoice-summary-value">+$0.00</p>
          </div>
          <div className="invoice-row">
            <p className="invoice-summary-label">Other charges and credits</p>
            <p className="invoice-summary-value">+$0.00</p>
          </div>
          <div className="invoice-row">
            <p className="invoice-summary-label">Government Fees and Taxes</p>
            <p className="invoice-summary-value">+$0.00</p>
          </div>
        </div>
        <div className="invoice-group">
          <div className="invoice-row">
            <h5 className="invoice-title">Total Current Charges</h5>
            <p className="invoice-summary-price">+$138.77</p>
          </div>
        </div>
        <div className="invoice-group" style={{ paddingTop: '10px' }}>
          <div className="invoice-row">
            <h5 className="invoice-title">Total Balance Due</h5>
            <p className="invoice-summary-price">+$63.77</p>
          </div>
        </div>
      </div>
    </div>
  );
}
